import { Paper, TableContainer } from "@mui/material";
import { styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { margin, padding } from "theme/defaultStyle";
import SignatureDefaultsContent from "./SignatureDefaultsContent";
import { IColumn } from "entities/ApiModel/IColumn";
import { useSignatureDefaults } from "utils/context/SignatureDefaultsContext";

const StyledPaper = styled(Paper)({
  backgroundColor: "transparent",
  boxShadow: "none",
  marginTop: margin.xsmall1,
  paddingBottom: padding.zero,
  paddingLeft: padding.xsmall,
  paddingRight: padding.xsmall,
  paddingTop: padding.zero,
});

const SignatureDefaultsTable = () => {
  const [, { getInitialColumnsDefintion, getColumnsDefinition }] = useSignatureDefaults();

  const [columns, setColumns] = useState<IColumn[]>(getInitialColumnsDefintion(false));

  useEffect(() => {
    const getColumns = async () => {
      const { gridColumns } = await getColumnsDefinition();
      setColumns(gridColumns);
    };

    getColumns();
  }, [getColumnsDefinition]);

  return (
    <TableContainer component={StyledPaper}>
      <SignatureDefaultsContent colsConfig={columns} />
    </TableContainer>
  );
};

export default SignatureDefaultsTable;
